"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jotai_1 = require("jotai");
var react_1 = __importStar(require("react"));
var activeIndexAtom = (0, jotai_1.atom)(undefined);
var nextIndexToRegisterAtom = (0, jotai_1.atom)(0);
var onStepClickAtom = (0, jotai_1.atom)(undefined);
/** This just exists so that we can use atoms in the context of this stepper's jotai provider */
var StepperInner = function (_a) {
    var children = _a.children, activeIndex = _a.activeIndex, onStepClick = _a.onStepClick;
    var setActiveIndex = (0, jotai_1.useSetAtom)(activeIndexAtom);
    (0, react_1.useEffect)(function () {
        setActiveIndex(activeIndex);
    }, [activeIndex]);
    var setOnStepClick = (0, jotai_1.useSetAtom)(onStepClickAtom);
    (0, react_1.useEffect)(function () {
        setOnStepClick(function () { return onStepClick; });
    }, [onStepClick]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
var Step = function (_a) {
    var children = _a.children;
    var _b = __read((0, react_1.useState)(), 2), myIndex = _b[0], setMyIndex = _b[1];
    var _c = __read((0, jotai_1.useAtom)(nextIndexToRegisterAtom), 2), nextIndexToRegister = _c[0], setNextIndexToRegister = _c[1];
    // Find out what my index is in relation to the other steps. This only runs once for each step.
    if (myIndex === undefined) {
        setMyIndex(nextIndexToRegister);
        setNextIndexToRegister(function (prev) { return prev + 1; });
    }
    var activeIndex = (0, jotai_1.useAtomValue)(activeIndexAtom);
    if (myIndex === activeIndex)
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    return null;
};
var StepsDisplay = function (_a) {
    var children = _a.children;
    var activeIndex = (0, jotai_1.useAtomValue)(activeIndexAtom);
    var onStepClick = (0, jotai_1.useAtomValue)(onStepClickAtom);
    var nextIndexToRegister = (0, jotai_1.useAtomValue)(nextIndexToRegisterAtom);
    // We will never hit this after StepperInner writes to onStepClickAtom
    // TODO: refine this?
    if (!onStepClick)
        return null;
    return react_1.default.createElement(react_1.default.Fragment, null, children({ activeIndex: activeIndex, onStepClick: onStepClick, numSteps: nextIndexToRegister }));
};
/**
 * Behavioral headless compound component that is useful on multi-page forms.
 *
 * Unmounts children of a step when that step is not active.
 *
 * @todo test putting two of them on the same page and make sure they don't share jotai state (our use of a jotai Provider should prevent that)
 */
var Stepper = function (_a) {
    var children = _a.children, activeIndex = _a.activeIndex, onStepClick = _a.onStepClick;
    return (react_1.default.createElement(jotai_1.Provider, null,
        react_1.default.createElement(StepperInner, { activeIndex: activeIndex, onStepClick: onStepClick }, children)));
};
Stepper.Step = Step;
Stepper.StepsDisplay = StepsDisplay;
exports.default = Stepper;
